import styled from '@emotion/styled';
import { Tab, Tabs } from '@mui/material';
import Box from '@mui/material/Box';

export const TabPanelContainer = styled('div')({
  backgroundColor: '#FFFFFF',
});

export const BoxPanel = styled(Box)({
  width: '100%',
  backgroundColor: '#FFFFFF',
  padding: 25,
});

export const StyledTabs = styled(Tabs)(({ theme, typevariant }) => ({
  '.MuiTabs-indicator': {
    backgroundColor: `${theme.palette.info.main}`,
    height: '2.5px',
  },
  borderBottom:
    typevariant === 'secondary'
      ? `3px solid ${theme.palette.info.main}`
      : `1px solid ${theme.palette.error.light}`,
}));
export const StyledTab = styled(Tab)(({ theme, typevariant, muted }) => ({
  backgroundColor:
    typevariant === 'secondary' ? theme.palette.background.grey : 'transparent',
  borderBottom: `1px solid ${theme.palette.error.light}`,
  fontSize: '14px',
  padding: '0px 40px',
  textTransform: 'capitalize',
  // Issue #1021, riapertura 2026-09-04, punti 25/32 — "in grigio" per il
  // cliente è uno stile, non un blocco all'interazione: a differenza di
  // `disabled` (MUI, non cliccabile) questo prop resta puramente visivo, la
  // tab continua a rispondere al click.
  opacity: muted ? 0.5 : 1,
  // fontWeight: 'bold',
  border: typevariant === 'secondary' ? '0.5px solid #F4F5F6' : 0,
  borderRadius: typevariant === 'secondary' ? '8px 8px 0px 0px' : 0,
  '&.Mui-selected': {
    color:
      typevariant === 'secondary'
        ? theme.palette.secondary.light
        : theme.palette.info.main,
    fontWeight: 'bold',
    backgroundColor:
      typevariant === 'secondary' ? theme.palette.info.main : 'inherit',
  },
  '&.MuiButtonBase-root': {
    textTransform: 'none',
    fontWeight: 'bold',
  },
}));
